<template>
  <div class="rank-container">
    <titleSwitch
      class="rank-title-switch"
      v-model="rankTitleKey"
      :itemList="rankTitleList"
      bgType="2"
    />
    <div class="table">
      <div class="table-title">
        <div class="rank-col">{{ getDict(260) /*排名*/ }}</div>
        <div class="name-col">{{ getDict(261) /*玩家名称*/ }}</div>
        <div
          class="recycle-col"
          :class="rankTitleKey == 'recycle_rate_rank' ? 'active' : ''"
        >
          <span>{{ getDict(262) /*回收率*/ }}</span>
        </div>
        <div
          class="hit-col"
          :class="rankTitleKey == 'hit_rate_rank' ? 'active' : ''"
        >
          <span>{{ getDict(263) /*命中率*/ }}</span>
        </div>
        <div
          class="gold-col"
          :class="rankTitleKey == 'gold_rank' ? 'active' : ''"
        >
          <span>{{ getDict(264) /*总资产*/ }}</span>
        </div>
        <div class="goto-log-col"></div>
      </div>
      <div class="list-box" ref="rankList" @scroll="onScrollRank">
        <div class="rank-item" v-for="(player, index) in rankList" :key="index">
          <div class="rank-col">
            <i
              v-if="index < 3"
              class="rank-icon"
              :class="'rank-' + (index + 1)"
            />
            <span v-if="index >= 3">{{ index + 1 }}</span>
          </div>
          <div class="name-col">
            <img class="icon" :src="player.icon || undefined" /><span>{{
              player.name
            }}</span>
          </div>
          <div
            class="recycle-col"
            :class="rankTitleKey == 'recycle_rate_rank' ? 'col-active' : ''"
          >
            <div class="col-line">
              {{ (player.recycle_rate * 100 || 0).toFixed(0) }}%
            </div>
            <div class="col-line">
              ({{ getRankText(player.recycle_rate_rank) }})
            </div>
          </div>
          <div
            class="hit-col"
            :class="rankTitleKey == 'hit_rate_rank' ? 'col-active' : ''"
          >
            <div class="col-line">
              {{ (player.hit_rate * 100 || 0).toFixed(0) }}%
            </div>
            <div class="col-line">
              ({{ getRankText(player.hit_rate_rank) }})
            </div>
          </div>
          <div
            class="gold-col"
            :class="rankTitleKey == 'gold_rank' ? 'col-active' : ''"
          >
            <div class="col-line">
              <i class="icon icon-gold-2" />{{ player.gold || 0 }}
            </div>
            <div class="col-line">({{ getRankText(player.gold_rank) }})</div>
          </div>
          <div class="goto-log-col" @click="goToLog(player)">
            {{ getDict(266) /*竞猜记录*/ }}>
          </div>
        </div>
      </div>
    </div>
    <portal to="gamblePageRightContentPortal">
      <div class="my-rank gamble-page-right-content-pddding">
        <span class="label-my">{{ getDict(267) /*我*/ }}</span>
        <div class="my-rank-info">
          <div class="rank-item">
            <div class="rank-col">
              <!-- <i v-if="index < 3" class="rank-icon" :class="'rank-'+(index + 1)"/>
              <span v-if="index >= 3">{{player.gold_rank}}</span> -->
              <span>{{ gambleUserInfo.gold }}</span>
            </div>
            <div class="name-col">
              <img class="icon" :src="gambleUserInfo.icon || undefined" /><span
                >{{ gambleUserInfo.name }}</span
              >
            </div>
            <div class="recycle-col">
              <div class="col-line">
                {{ (gambleUserInfo.recycle_rate * 100 || 0).toFixed(0) }}%
              </div>
              <div class="col-line">
                ({{ getRankText(gambleUserInfo.recycle_rate_rank) }})
              </div>
            </div>
            <div class="hit-col">
              <div class="col-line">
                {{ (gambleUserInfo.hit_rate * 100 || 0).toFixed(0) }}%
              </div>
              <div class="col-line">
                ({{ getRankText(gambleUserInfo.hit_rate_rank) }})
              </div>
            </div>
            <div class="gold-col">
              <div class="col-line">
                <i class="icon icon-gold-2" />{{ gambleUserInfo.gold || 0 }}
              </div>
              <div class="col-line">
                ({{ getRankText(gambleUserInfo.gold_rank) }})
              </div>
            </div>
            <div class="goto-log-col" @click="goToLog()">
              {{ getDict(268) /*我的竞猜记录*/ }}>
            </div>
          </div>
        </div>
      </div>
    </portal>
  </div>
</template>

<script>
import {
  getDict,
  axios,
  getPageLevelMixin,
  webSocket,
  serverApi,
} from "../../../../common";
import store from "@/store";
import { mapState, mapGetters } from "vuex";

// import gamblePopComp from '../../comps/gamble-pop-comp'
import titleSwitch from "../../comps/title-switch";

export default {
  name: "rankPage",
  mixins: [getPageLevelMixin],
  props: {},
  data() {
    return {
      pageLevel: 1,

      pageLimit: 20,
      devReplyTime: 0,

      /*rankList:[
        ...Array(100).fill({}).map((item,index)=>{
          item = {
            uid:(index + 1),
            name:'play' + (index + 1),
            icon:'https://nie.res.netease.com/r/pic/20200603/187bb5a3-5d56-4577-b2f7-552f83c10846.png',
            
            gold:1000,
            hit_rate:0.1,
            recycle_rate: 0.1,

            gold_rank:(index + 1),
            hit_rate_rank:(index + 1),
            recycle_rate_rank: (index + 1),
          }
          return item;
        })
      ],*/

      rankTitleKey: "recycle_rate_rank",
      rankTitleList: [
        {
          name: getDict(262) /*回收率*/,
          key: "recycle_rate_rank",
          list: [],
          loading: false,
          nextCursor: 0,
        },
        {
          name: getDict(263) /*命中率*/,
          key: "hit_rate_rank",
          list: [],
          loading: false,
          nextCursor: 0,
        },
        {
          name: getDict(264) /*总资产*/,
          key: "gold_rank",
          list: [],
          loading: false,
          nextCursor: 0,
        },
      ],

      listStatus: {
        height: 0,
        boxHeight: 0,
        top: 0,
      },
    };
  },
  computed: {
    // ...mapState(['userData']),
    ...mapGetters(["gambleUserInfo"]),
    activeRankObj() {
      return (
        this.rankTitleList.find((obj) => obj.key == this.rankTitleKey) || null
      );
    },
    rankList() {
      return this.activeRankObj ? this.activeRankObj.list : [];
    },
  },
  watch: {
    rankList() {
      this.$nextTick(() => {
        console.log(this.rankList);
        this.resetListStatus(true);
      });
    },
    rankTitleKey() {
      this.$refs.rankList.scrollTop = 0;
    },
  },
  methods: {
    getDict,
    getRankText(rank = 0) {
      return rank && rank < 1000 ? getDict(265, [rank]) /*第${1}名*/ : "999+"; //getDict(269); /*榜外*/
    },
    goToLog(user) {
      this.$emit("showQuizLog", user);
    },
    async getRankList(obj) {
      if (obj.nextCursor == -1 || obj.loading) {
        return;
      }
      let pageSize = this.pageLimit;
      //调试用
      if (this.devReplyTime) {
        pageSize = Math.ceil(pageSize / this.devReplyTime);
      }
      obj.loading = true;
      let res = await serverApi.get(obj.key, {
        cursor: obj.nextCursor,
        limit: pageSize,
      });
      obj.loading = false;
      if (res.code == 200) {
        if (res.data.users) {
          let addList = (res.data.users || []).map((user) => ({
            ...user,
            icon: user.icon ? user.icon.replace(/^http:/, "") : "",
          }));

          //调试用
          if (this.devReplyTime) {
            let list1 = [];
            for (let item of addList) {
              for (let index = 0; index < this.devReplyTime; index++) {
                list1.push({
                  ...item,
                });
              }
            }
            addList = list1;
          }
          obj.list = obj.list.concat(addList);
        }
        obj.nextCursor = +res.data.next_cursor || 0;
      }
    },
    onScrollRank() {
      this.resetListStatus();
      if (
        this.listStatus.top + 3 * this.listStatus.boxHeight >
        this.listStatus.height
      ) {
        if (this.activeRankObj) {
          this.getRankList(this.activeRankObj);
        }
      }
    },
    resetListStatus(widthChange = false) {
      if (!this.$refs.rankList) {
        return;
      }
      if (widthChange) {
        this.listStatus.boxHeight = this.$refs.rankList.clientHeight;
        this.listStatus.height = this.$refs.rankList.scrollHeight;
      }
      this.listStatus.top = this.$refs.rankList.scrollTop;
    },
  },
  components: {
    titleSwitch,
  },
  mounted() {
    this.$nextTick(() => {
      this.resetListStatus(true);
    });

    this.$busOn("setRemUnit", () => {
      //$busOn
      this.resetListStatus(true);
    });
  },
  created() {
    store.dispatch("gambleGetUserInfo");
    this.rankTitleList.map((obj) => {
      this.getRankList(obj);
    });
  },
};
</script>

<style lang="scss" scoped>
$rank-item-height: 0.85rem;
$all-width: 1107;
$rank-col-width: 128;
$name-col-width: 180; //111;
$recycle-col-width: 195;
$hit-col-width: 195;
$gold-col-width: 195;
$goto-log-col-width: $all-width - $rank-col-width - $name-col-width -
  $recycle-col-width - $hit-col-width - $gold-col-width;

.rank-col,
.name-col,
.recycle-col,
.hit-col,
.gold-col,
.goto-log-col {
  display: inline-block;
}

.rank-col {
  width: $rank-col-width/$all-width * 100%;
  flex-grow: $rank-col-width;
}
.name-col {
  width: $name-col-width/$all-width * 100%;
  flex-grow: $name-col-width;
}
.recycle-col {
  width: $recycle-col-width/$all-width * 100%;
  flex-grow: $recycle-col-width;
}
.hit-col {
  width: $hit-col-width/$all-width * 100%;
  flex-grow: $hit-col-width;
}
.gold-col {
  width: $gold-col-width/$all-width * 100%;
  flex-grow: $gold-col-width;
}
.goto-log-col {
  // width:$goto-log-col-width/$all-width * 100%;
  width: #{$goto-log-col-width / 100}rem;
}

.list-box,
.my-rank-info {
  .rank-item {
    height: $rank-item-height;
    display: flex;
    font-size: 0.2rem;
    // &:nth-child(2n){
    //   background-color: rgba(255,255,255,0.2);
    // }

    .col-line {
      display: flex;
      align-items: center;
    }

    .rank-col,
    .name-col,
    .recycle-col,
    .hit-col,
    .gold-col,
    .goto-log-col {
      display: flex;
      justify-content: center;
      align-items: center;
      // color:#292829;
    }
    .rank-col {
      font-size: 0.26rem;

      .rank-icon {
        width: 0.52rem;
        height: 0.37rem;
        background-size: 100% 100%;
      }
      .rank-1 {
        background-image: url(./imgs/rank-1.png);
      }
      .rank-2 {
        background-image: url(./imgs/rank-2.png);
      }
      .rank-3 {
        background-image: url(./imgs/rank-3.png);
      }
    }
    .name-col {
      .icon {
        $size: 0.45rem;
        width: $size;
        height: $size;
        border-radius: 50%;
      }
    }
    .recycle-col,
    .hit-col,
    .gold-col {
      flex-direction: column;
    }
  }
}

.rank-container {
  display: flex;
  flex: 1;
  height: 0;
  flex-direction: column;
  align-items: center;
  .rank-title-switch {
    // padding: 0 1rem;
  }

  .table {
    $table-width: 100%; //11rem;
    width: $table-width;
    height: 0;
    flex: 1;
    display: flex;
    flex-direction: column;

    .table-title {
      $title-height: 0.37rem;
      display: flex;
      width: $table-width;
      height: 0.37rem;
      background: url(./imgs/title-bg.png) no-repeat;
      background-size: 100% 100%;
      text-align: center;
      color: #fff;
      font-size: 0.2rem;

      .rank-col,
      .name-col,
      .recycle-col,
      .hit-col,
      .gold-col,
      .goto-log-col {
        height: $title-height;
        line-height: $title-height;
        &.active {
          background-color: #ffcd54;
          border: 0.01rem #fff solid;

          span {
            position: relative;
            background-image: -webkit-linear-gradient(
              -104deg,
              #5c1413,
              #e04445
            );
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }
        }
      }
    }

    .list-box {
      height: 0;
      flex: 1;
      overflow-x: hidden;
      overflow-y: auto;
      // background-color: rgba(255, 255, 255, 0.2);
      border: solid #eee;
      border-width: 0 1px;

      .rank-item {
        // height: 0.85rem;
        // display: flex;
        // font-size: 0.2rem;
        &:nth-child(2n) {
          background-color: rgba(#061e39, 0.4);
        }
        &:last-child {
          margin-bottom: $rank-item-height;
        }

        // .col-line{
        //   display: flex;
        //   align-items: center;
        // }

        .rank-col,
        .name-col,
        .recycle-col,
        .hit-col,
        .gold-col,
        .goto-log-col {
          // display: flex;
          // justify-content: center;
          // align-items: center;
          color: #fff;

          &.col-active {
            color: #ffd673;
          }
        }
        .rank-col {
          color: #bf8137;
        }
        // .name-col{
        //   .icon{
        //     $size:0.45rem;
        //     width: $size;
        //     height: $size;
        //     border-radius: 50%;
        //   }
        // }
        .recycle-col,
        .hit-col,
        .gold-col {
          color: #83643f;
        }
        .goto-log-col {
          color: #83643f;
        }
      }
    }
  }
}

.my-rank {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 0.85rem;
  background: url(./imgs/buttom-bg.png) no-repeat;
  background-size: auto 100%;
  background-position: left;
  background-color: #252328;

  .label-my {
    position: absolute;
    top: 0.1rem;
    left: 0.1rem;
    font-size: 0.22rem;
    line-height: 1em;
    color: #ffee8e;
    font-weight: 600;
  }

  .my-rank-info {
    color: #fff;
  }
}
</style>
